module.exports = __webpack_public_path__ + "static/media/saas2-slider.2d3ce977.png";